import { feedbackObjectIsOpen$ } from "@/views/CourseStudent/CourseContent/Feedback/feedback-component.service";
import { needsToPause$ } from "@/views/CourseStudent/course-student.service";
import { SpeechActions } from "./actions";

class Tests {
  static readonly OPEN_CHAT = /[A-z]?(preciso de ajuda|me ajude|ajuda)/gi;
  static readonly RECORD_QUIZ = /[A-z]?(responder)/gi;
}
class States {
  static check(key: RegExp, result: string): boolean {
    return new RegExp(key).test(result);
  }

  static openChat(result: string): boolean {
    return (
      this.check(Tests.OPEN_CHAT, result) &&
      feedbackObjectIsOpen$.value !== true &&
      SpeechActions.skipHasOpened$.value !== true
    );
  }

  static recordQuiz(result: string): boolean {
    return this.check(Tests.RECORD_QUIZ, result);
  }
}

function speechActions(result: string): void {
  if (States.openChat(result)) {
    SpeechActions.chatOpen(true);
    needsToPause$.next(true);
  } else if (States.recordQuiz(result)) {
    SpeechActions.quizRecord(true);
  }
}

function sttEvents(result: string): void {
  speechActions(result);
}

export { sttEvents };
